'use client';

import { cn } from '~/lib/utils';

type DrawerFooterProps = {
  children: React.ReactNode;
  className?: string;
};

export default function DrawerFooter({ children, className }: DrawerFooterProps) {
  return (
    <footer
      className={cn(
        'border-border/60 bg-background flex shrink-0 items-center justify-end gap-2 border-t px-5 py-3.5',
        className,
      )}
    >
      {children}
    </footer>
  );
}
